<!-- Equivalent of old h4 in modals -->
<h1 class="pull-left">{{text}}</h1>
